
class CustomMobilePromoSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.swiperReadyHandler = null;
  }

  connectedCallback() {
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    if (this.swiperReadyHandler) {
      window.removeEventListener('swiper:ready', this.swiperReadyHandler);
      this.swiperReadyHandler = null;
    }
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.swiper');
    if (!swiperContainer) return;

    if (typeof window.Swiper === 'undefined') {
      if (window.RO && typeof window.RO.loadSwiper === 'function') {
        window.RO.loadSwiper().catch(() => {});
      }

      if (!this.swiperReadyHandler) {
        this.swiperReadyHandler = () => {
          this.swiperReadyHandler = null;
          this.initSwiper();
        };
        window.addEventListener('swiper:ready', this.swiperReadyHandler, { once: true });
      }
      return;
    }

    this.swiper = new window.Swiper(swiperContainer, {
      slidesPerView: "auto",
      spaceBetween: 12,
      grabCursor: true,
      navigation: {
        nextEl: this.querySelector('.custom-promo-slider__nav--next'),
        prevEl: this.querySelector('.custom-promo-slider__nav--prev'),
      },
    });
  }
}

if (!customElements.get('custom-mobile-promo-slider')) {
  customElements.define('custom-mobile-promo-slider', CustomMobilePromoSlider);
}
